import Logo from '@/assets/images/logo.png';
import Router from '@/router/index';
import { Helmet } from 'react-helmet-async';
import { MotionLazy } from './components/animate/motion-lazy';
import Toast from './components/toast';
import { AntdAdapter } from './theme/adapter/antd.adapter';
import { ThemeProvider } from './theme/theme-provider';
import { TimezoneProvider } from './contexts/TimezoneContext';
function App() {
  return (
    <ThemeProvider adapters={[AntdAdapter]}>
      <TimezoneProvider>
        <Helmet>
          <title>FDTV+ Admin</title>
          <link rel="icon" href={Logo} />
        </Helmet>
        <Toast />
        
        <MotionLazy>
          <Router />
        </MotionLazy>
      </TimezoneProvider>
    </ThemeProvider>
  );
}

export default App;
